import type { LogoProps } from '../../logo.types'
import { logos, symbols } from './logos'

type LogoUniversProps = LogoProps & {
  onlySymbol?: boolean
}

export const LogoUnivers = (props: LogoUniversProps) => {
  const { size, type, onlySymbol = false } = props

  if (onlySymbol) {
    return symbols[type][size]
  }

  return logos[type][size]
}
